// removed by extract-text-webpack-plugin
module.exports = {"base":"Status_base--2RLkO","holder":"Status_holder--798ey","content":"Status_content--2grUB","title":"Status_title--m4sYD","timer":"Status_timer--2NUZi","base__soon":"Status_base__soon--2SMkZ","baseSoon":"Status_base__soon--2SMkZ"};


//////////////////
// WEBPACK FOOTER
// ./components/BattleWizard/components/Status/Status.scss
// module id = 514
// module chunks = 11 12